import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../../../app/stores/store';

interface Props {
  id: string;
}
function MicroLoaderViewPage({ id }: Props) {
  const { activityStore } = useStore();
  const [durationInSeconds, setDurationInSeconds] = useState(0);
  const [startEndDuration, setStartEndDuration] = useState<number[]>([]);

  let timeDuration: number[] = [];

  let videoData = activityStore.peopleSelected?.info?.filter((word: any) => {
    return word.id === id;
  });

  function convert(input: string) {
    var parts = input.split(':'),
      minutes = +parts[0],
      seconds = +parts[1];
    return (minutes * 60 + seconds).toFixed(3);
  }

  useEffect(() => {
    setStartEndDuration([]);
    setDurationInSeconds(0);

    let JsonData = videoData[0]?.ts;

    if (JsonData) {
      JsonData.forEach((element: any) => {
        convert(element.start); //gives second for start
        convert(element.end); //end Data
        for (
          let i = parseInt(convert(element.start));
          i <= parseInt(convert(element.end));
          i++
        ) {
          setStartEndDuration((oldState) => [...oldState, i]);
        }
      });
    }
    let MainDuration = videoData[0]?.duration;
    if (MainDuration) {
      setDurationInSeconds(parseInt(convert(videoData[0].duration)));
    }

    // eslint-disable-next-line
  }, [activityStore.peopleSelected]);

  for (let i = 0; i <= durationInSeconds; i++) {
    if (startEndDuration.includes(i)) {
      timeDuration.push(1);
    } else {
      timeDuration.push(0);
    }
  }

  return (
    <div key={id}>
      <div className="bar-view-clipper">
        <div className="bar-view-wrapper">
          {timeDuration.map((i) => {
            return <span className={`bar${i}`}></span>;
          })}
        </div>
      </div>
    </div>
  );
}

export default observer(MicroLoaderViewPage);
